import { render, staticRenderFns } from "./NlpBurger.vue?vue&type=template&id=07a7c152&scoped=true"
import script from "./NlpBurger.vue?vue&type=script&lang=js"
export * from "./NlpBurger.vue?vue&type=script&lang=js"
import style0 from "./NlpBurger.vue?vue&type=style&index=0&id=07a7c152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a7c152",
  null
  
)

export default component.exports